import "core-js/stable";
import "regenerator-runtime/runtime";
/*

Inclide the above,
set minSdk in config to 19 


 "browserslist": [
    "Android >= 5",
    "IOS >= 10",
    "Safari >= 11",
    "Chrome >= 38",
    "ChromeAndroid >= 38",
    "Firefox >= 31",
    "Samsung >= 5"
  ],
 cordova plugin rm cordova-plugin-crosswalk-webview
  */

import Vue from "vue";
// import "@/stylus/main.styl"
import vuetify from "./plugins/vuetify";
//import AsyncComputed from "vue-async-computed";
import "./registerServiceWorker";
//import firebaseApp from '@/external/firebaseInit';

import moment from "moment-timezone";
//import DatePicker from "vue2-datepicker";
import VueResource from "vue-resource";
import VueLodash from "vue-lodash";
//import JsonExcel from "vue-json-excel";
import * as VueGoogleMaps from "vue2-google-maps";
import filter from "@/components/Filter/filter";
import toptoolbar from "@/components/toolbar/toolbar";
import datepicker2 from "@/components/datepicker/datepicker";
//import Vue2TouchEvents from "vue2-touch-events";
import VueSweetalert2 from "vue-sweetalert2";
//import Datetime from "vue-datetime";
//import "vue-datetime/dist/vue-datetime.css";
import VueMq from "vue-mq";
import VueSocketIO from "vue-socket.io";
//import VModal from "vue-js-modal";
//import VueDraggable from "vuedraggable";

import store from "./store";
import router from "./router";
import App from "./App.vue";

import VModal from "vue-js-modal";

//import JsonCSV from "vue-json-csv";

//import imagePopup from "@/components/ImagePopup/imagePopup.js";

//window.firebaseApp =firebaseApp

//import VueQrcodeReader from "vue-qrcode-reader";

//Vue.use(VueQrcodeReader);

import VueSignaturePad from "vue-signature-pad";

Vue.use(VueSignaturePad);

import DatetimePicker from 'vuetify-datetime-picker'
// (Optional) import 'vuetify-datetime-picker/src/stylus/main.styl'

Vue.use(DatetimePicker)

import VueQRCodeComponent from "vue-qrcode-component";

//import vueAnimate from "vue2-animate/dist/vue2-animate.min.css";

// Register the Vue component
Vue.component("qr-code", VueQRCodeComponent);

//Vue.use(imagePopup)
Vue.use(require("vue-moment"), {
  moment
});

Vue.use(
  new VueSocketIO({
    debug: false,
    reconnect: true,
    connection: process.env.VUE_APP_REALTIMESOCKETURL
  })
);

//Vue.use(AsyncComputed);

//Vue.use(Datetime);

//Vue.use(Vue2TouchEvents);
Vue.use(VueMq, {
  breakpoints: {
    mobile: 450,
    tablet: 900,
    laptop: 1250,
    desktop: Infinity
  }
});
Vue.use(VueLodash);
//Vue.component("downloadExcel", JsonExcel);

//Vue.component("downloadCsv", JsonCSV);

Vue.component("user-filter", filter);
Vue.component("top-toolbar", toptoolbar);
Vue.component("full-datepicker", datepicker2);
const options = {
  confirmButtonColor: "#41b882",
  cancelButtonColor: "#ff7674"
};

Vue.use(VueSweetalert2, options);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyD7I-CM6G3BPSZG_jp6YJA6ctpB2Ie5844",
    libraries: "places" // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    // // If you want to set the version, you can do so:
    // v: '3.26',
  }

  // // If you intend to programmatically custom event listener code
  // // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  // // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  // autobindAllEvents: false,
  // // you might need to turn this on.

  // // If you want to manually install components, e.g.
  // // import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  // // Vue.component('GmapMarker', GmapMarker)
  // // then disable the following:
  // installComponents: true,
});

Vue.use(VModal, {
  dynamic: true,
  injectModalsContainer: true
});
/*
Vue.use(require("vue-moment"), {
  moment
}); */

//Vue.use(vueAnimate);

Vue.use(VueResource);
//Vue.use(VueDraggable);

// Adding Authorization to all interceptors
Vue.http.interceptors.push((request, next) => {
  try {
    const accessToken = JSON.parse(window.localStorage.getItem("vuex")).user.id;
    request.headers.set("authorization", accessToken);
    request.query.params.access_token = accessToken;
    console.log(request);
  } catch (e) {}
  next();
});

Vue.http.interceptors.push((request, next) => {
  //request.headers['Authorization'] = auth.getAuthHeader()
  next(response => {
    if (response.status == 500 && response.body.error.message == "Unauthenticated") {
      try {
        Vue.$http
          .post(`${Vue.$store.state.endpoint}Accounts/logout`)
          .then(res => {
            try {
              firebase
                .auth()
                .signOut()
                .then(() => {
                  window.localStorage.clear();
                  window.location.reload();
                })
                .catch(err => {
                  console.log(err);

                  window.localStorage.clear();
                  window.location.reload();
                });
            } catch (e) {
              console.log(e);

              window.localStorage.clear();
              window.location.reload();
            }
          })
          .catch(err => {
            window.localStorage.clear();
            window.location.reload();
          });

        //
      } catch (e) {
        console.log(e);

        window.localStorage.clear();
        window.location.reload();
      }
    }
  });
});

Vue.config.productionTip = false;

String.prototype.insert = function(index, string) {
  if (index > 0) return this.substring(0, index) + string + this.substring(index, this.length);

  return string + this;
};

//require("./utilities/firebase")

window.App = new Vue({
  vuetify,
  router,
  store,
  render(h) {
    return h(App);
  }
}).$mount("#app");

/*
//Setup notifications

const messaging = firebase.messaging();


messaging.getToken().then((currentToken) => {
  if (currentToken) {
    sendTokenToServer(currentToken);
    
  } else {
    // Show permission request.
    console.log('No Instance ID token available. Request permission to generate one.');
    // Show permission UI.
    requestPermission()
    setTokenSentToServer(false);
  }
}).catch((err) => {
  console.log('An error occurred while retrieving token. ', err);
  showToken('Error retrieving Instance ID token. ', err);
  setTokenSentToServer(false);
});
messaging.onTokenRefresh(() => {
  messaging.getToken().then((refreshedToken) => {
    console.log('Token refreshed.');
    // Indicate that the new Instance ID token has not yet been sent to the
    // app server.
    setTokenSentToServer(false);
    // Send Instance ID token to app server.
    sendTokenToServer(refreshedToken);
    // [START_EXCLUDE]
    // Display new Instance ID token and clear UI of all previous messages.
   // resetUI();
    // [END_EXCLUDE]
  }).catch((err) => {
    console.log('Unable to retrieve refreshed token ', err);
    showToken('Unable to retrieve refreshed token ', err);
  });
});


function sendTokenToServer(currentToken) {
  if (!isTokenSentToServer()) {
    console.log('Sending token to server...');
    // TODO(developer): Send the current token to your server.
    setTokenSentToServer(true);
  } else {
    console.log('Token already sent to server so won\'t send it again ' +
        'unless it changes');
  }
}


function isTokenSentToServer() {
  return window.localStorage.getItem('sentToServer') === '1';
}
function setTokenSentToServer(sent) {
  window.localStorage.setItem('sentToServer', sent ? '1' : '0');
}

function requestPermission() {
  console.log('Requesting permission...');
  // [START request_permission]
  Notification.requestPermission().then((permission) => {
    if (permission === 'granted') {
      console.log('Notification permission granted.');
      // TODO(developer): Retrieve an Instance ID token for use with FCM.
      // [START_EXCLUDE]
      // In many cases once an app has been granted notification permission,
      // it should update its UI reflecting this.
      resetUI();
      // [END_EXCLUDE]
    } else {
      console.log('Unable to get permission to notify.');
    }
  });
  // [END request_permission]
}


messaging.onMessage((payload) => {
  console.log('Message received. ', payload);
  
  store.dispatch('getNotifications');
  
});



function deleteToken() {
  // Delete Instance ID token.
  // [START delete_token]
  messaging.getToken().then((currentToken) => {
    messaging.deleteToken(currentToken).then(() => {
      console.log('Token deleted.');
      setTokenSentToServer(false);
      // [START_EXCLUDE]
      // Once token is deleted update UI.
      resetUI();
      // [END_EXCLUDE]
    }).catch((err) => {
      console.log('Unable to delete token. ', err);
    });
    // [END delete_token]
  }).catch((err) => {
    console.log('Error retrieving Instance ID token. ', err);
    showToken('Error retrieving Instance ID token. ', err);
  });
}
  
*/
